<template>
  <span>
    <!-- :class="{'rightActive': rightPanelActive}" -->
    <div v-if="loadingMap" class="overlay">
      <img class="loading-animation" src="../assets/squares.gif">
    </div>

    <div id='map'>
    </div>
  </span>
</template>

<script>
var GoogleMapsLoader = require('google-maps')
var algoliasearch = require('algoliasearch')
var InfoBubble = require('js-info-bubble')
var MarkerClusterer = require('marker-clusterer-plus')
var _ = require('lodash')
import { mapState, mapActions } from 'vuex'
import router from '@/router'

GoogleMapsLoader.KEY = 'AIzaSyAhR-P2aVjRaudax5LwOtldWQyBAfuJnCI'
var styles = [{'featureType': 'administrative', 'elementType': 'labels.text.fill', 'stylers': [{'color': '#444444'}]}, {'featureType': 'landscape', 'elementType': 'all', 'stylers': [{'color': '#f2f2f2'}]}, {'featureType': 'poi', 'elementType': 'all', 'stylers': [{'visibility': 'off'}]}, {'featureType': 'road', 'elementType': 'all', 'stylers': [{'saturation': -100}, {'lightness': 45}]}, {'featureType': 'road.highway', 'elementType': 'all', 'stylers': [{'visibility': 'simplified'}]}, {'featureType': 'road.arterial', 'elementType': 'labels.icon', 'stylers': [{'visibility': 'off'}]}, {'featureType': 'transit', 'elementType': 'all', 'stylers': [{'visibility': 'off'}]}, {'featureType': 'water', 'elementType': 'all', 'stylers': [{'color': '#D9E8F1'}, {'visibility': 'on'}]}, {'featureType': 'administrative', 'elementType': 'geometry.fill', 'stylers': [{ 'visibility': 'off' }]}, {'featureType': 'administrative', 'elementType': 'geometry', 'stylers': [{ 'visibility': 'off' }]}, { 'featureType': 'all', 'elementType': 'labels.text', 'stylers': [{ 'visibility': 'off' }] }]

// import {
//     openRightPanel,
//     setCurrentTrip,
//     setCurrentDest,
//     setRegions,
//     setTypes
//   } from '../vuex/actions'

export default {
  data () {
    return {
      trips: {},
      map: {},
      markers: [],
      initSeach: false,
      buildFilters: false,
      loadingMap: true
    }
  },
  mounted: function () {
    this.searchAlgolia()
  },
  methods: {
    ...mapActions({
      setRegions: 'setRegions',
      setTypes: 'setTypes'
    }),
    markerIconPicker (trip, currentDest) {
      var activeGrayIcon = require('../assets/gray-lg-icon.png')
      var grayIcon = require('../assets/gray-icon.png')
      var blueIcon = require('../assets/blue-icon.png')
      var activeBlueIcon = require('../assets/blue-lg-icon.png')
      var mediumBlueIcon = require('../assets/medium-blue-icon.png')
      var activeMediumBlueIcon = require('../assets/medium-blue-lg-icon.png')

      if (!_.has(trip, 'acf.featured_trip')) { return }
      if (trip.types.indexOf('future-trips') !== -1) {
        if (currentDest || trip.acf.featured_trip) {
          return activeGrayIcon
        }
        return grayIcon
      } else if (trip.types.indexOf('faculty-led') !== -1) {
        if (currentDest || trip.acf.featured_trip) {
          return activeBlueIcon
        }
        return blueIcon
      } else {
        if (currentDest || trip.acf.featured_trip) {
          return activeMediumBlueIcon
        }
        return mediumBlueIcon
      }
    },
    colorPicker (trip, currentDest = false) {
      if (trip.types.indexOf('future-trips') !== -1) {
        return '#5C5C5C'
      } else if (trip.types.indexOf('faculty-led') !== -1) {
        return '#043969'
      } else {
        return '#003DA7'
      }
    },
    buildMap: function (content) {
      this.map = {}
      this.markers = []
      var icon
      var color
      // Google Maps
      GoogleMapsLoader.load((google) => {
        this.map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: 0, lng: 0},
          zoom: 2,
          mapTypeControl: false
        })

        this.map.addListener('idle', () => {
          this.loadingMap = false
        })

        var bounds = new google.maps.LatLngBounds()
        var i
        if (content.hits) {
          _.each(content.hits, (hit) => {
            if (!_.has(hit, 'acf.destinations')) { return }
            icon = this.markerIconPicker(hit)
            color = this.colorPicker(hit)
            var lat = Number(hit.acf.destinations[0].location.lat)
            var lng = Number(hit.acf.destinations[0].location.lng)
            var marker = new google.maps.Marker({
              position: {lat: lat, lng: lng},
              map: this.map,
              trip: hit,
              icon: icon,
              html: '<div class="infoBox ' + hit.types[0] + '"><div class="infoBoxImg" style="background-image:url(' + hit.acf.destinations[0].gallery[0].url + ');"></div><p>' + hit.title.rendered + '</p></div>'
            })
            var latlng = new google.maps.LatLng(lat, lng)
            bounds.extend(latlng)

            marker.addListener('click', function () {
              router.push({ name: 'Trip', params: { id: marker.trip.slug } })
            })

            // if marker contains HTML, add it to an infoWindow
            var tripTitle = hit.title.rendered
            if (tripTitle.length > 16) {
              tripTitle = tripTitle.substring(0, 16)
              tripTitle = tripTitle + '...'
            }
            var a = 1
            var infoBubble = new InfoBubble({
              map: this.map,
              content: '<div class="infoBox  ' + hit.types[0] + '"><div class="infoBoxImg" style="background-image:url(' + hit.acf.destinations[0].gallery[0].sizes.mapHover + ');"></div><p>' + tripTitle + '</p></div>',
              position: new google.maps.LatLng(lat, lng),
              shadowStyle: 0,
              padding: 0,
              backgroundColor: color,
              borderRadius: 0,
              arrowSize: 10,
              borderWidth: 1,
              borderColor: color,
              disableAutoPan: true,
              hideCloseButton: true,
              arrowPosition: 50,
              backgroundClassName: 'transparent',
              arrowStyle: 0,
              maxWidth: 125,
              maxHeight: 104
            })

            // show info window when marker is clicked
            var isTouchDevice = 'ontouchstart' in window
            if (isTouchDevice) {
              marker.addListener('mouseover', () => {
                window.setTimeout(() => {
                  infoBubble.open(this.map, marker)
                  jQuery(infoBubble.bubble_).live('click', () => {
                    router.push({ name: 'Trip', params: { id: marker.trip.slug } })
                  })
                }, 1000)
              })
            } else {
              marker.addListener('mouseover', () => {
                infoBubble.open(this.map, marker)
                jQuery(infoBubble.bubble_).live('click', () => {
                  router.push({ name: 'Trip', params: { id: marker.trip.slug } })
                })
              })
            }
            marker.addListener('mouseout', () => {
              infoBubble.close(this.map, marker)
            })
            this.markers.push(marker)

            var MapMarkerClusterer = new MarkerClusterer(this.map, this.markers)
          })
        }

        if (bounds) {
          var sw = bounds.getSouthWest()
          var ne = bounds.getNorthEast()

          var lat1 = sw.lat()
          var lng1 = sw.lng()
          var lat2 = ne.lat()
          var lng2 = ne.lng()

          var dx = (lng1 - lng2) / 2
          var dy = (lat1 - lat2) / 2
          var cx = (lng1 + lng2) / 2
          var cy = (lat1 + lat2) / 2

          // work around a bug in google maps...
          lng1 = cx + dx
          lng2 = cx - dx
          lat1 = cy + dy
          lat2 = cy - dy

          sw = new google.maps.LatLng(lat1, lng1)
          ne = new google.maps.LatLng(lat2, lng2)
          bounds = new google.maps.LatLngBounds(sw, ne)

          this.map.fitBounds(bounds)
        }
        var markerCluster = new MarkerClusterer(this.map, this.markers)
      })
    },
    reBuildMap (trip) {
      var map = {}
      var markers = []
      var icon = this.markerIconPicker(trip)
      // Google Maps
      GoogleMapsLoader.load((google) => {
        this.map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: 0, lng: 0},
          zoom: 2,
          styles: styles,
          mapTypeControl: false
        })

        that.map.addListener('idle', () => {
          that.loadingMap = false
        })

        var destPathCoords = []
        var bounds = new google.maps.LatLngBounds()
        var viewBounds = new google.maps.LatLngBounds()
        var i
        for (i = 0; i < trip.acf.destinations.length; ++i) {
          var lat = Number(trip.acf.destinations[i].location.lat)
          var lng = Number(trip.acf.destinations[i].location.lng)
          var marker = new google.maps.Marker({
            position: {lat: lat, lng: lng},
            map: that.map,
            dest: trip.acf.destinations[i],
            icon: icon
          })
          destPathCoords.push({'lat': lat, 'lng': lng})
          var latlng = new google.maps.LatLng(lat, lng)
          bounds.extend(latlng)
          viewBounds.extend(latlng)

          marker.addListener('click', function () {
            that.setCurrentDest(this.dest)
          })
          that.markers.push(marker)
        }

        var destPath = new google.maps.Polyline({
          path: destPathCoords,
          geodesic: true,
          strokeColor: '#bdc7d1',
          strokeOpacity: 1.0,
          strokeWeight: 2
        })

        destPath.setMap(that.map)

        // var prev
        // var jwlat1
        // var jwlng1
        // for (var j = destPathCoords.length - 1; j >= 0; j--) {
        //   if (prev) {
        //     jwlat1 = (Math.max(prev.lat, destPathCoords[j].lat) - Math.min(prev.lat, destPathCoords[j].lat))
        //     jwlng1 = (Math.max(prev.lng, destPathCoords[j].lng) + Math.min(prev.lng, destPathCoords[j].lng)) / 2
        //     var curvedLine = new GmapsCubicBezier(prev.lat, prev.lng, jwlat1, jwlng1, destPathCoords[j].lat, destPathCoords[j].lng, destPathCoords[j].lat, destPathCoords[j].lng, 0.1, that.map)
        //   }
        //   prev = destPathCoords[j]
        // }

        if (bounds) {
          var sw = bounds.getSouthWest()
          var ne = bounds.getNorthEast()

          var lat1 = sw.lat()
          var lng1 = sw.lng()
          var lat2 = ne.lat()
          var lng2 = ne.lng()

          var dx = (lng1 - lng2) / 2
          var dy = (lat1 - lat2) / 2
          var cx = (lng1 + lng2) / 2
          var cy = (lat1 + lat2) / 2

          // work around a bug in google maps...
          lng1 = cx + dx
          lng2 = cx - dx
          lat1 = cy + dy
          lat2 = cy - dy * 1.5

          sw = new google.maps.LatLng(lat1, lng1)
          ne = new google.maps.LatLng(lat2, lng2)
          bounds = new google.maps.LatLngBounds(sw, ne)

          // Don't zoom in too far on only one marker
          if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.03, bounds.getNorthEast().lng() + 0.03)
            var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.03, bounds.getNorthEast().lng() - 0.03)
            bounds.extend(extendPoint1)
            bounds.extend(extendPoint2)
          }
          that.map.fitBounds(bounds)
        }
        /* Rectangle to visualize viewport bounds, uncomment to turn on
        var rectangle = new google.maps.Rectangle({
          strokeColor: '#ff0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#ff0000',
          fillOpactiy: 0.35,
          map: that.map,
          bounds: viewBounds
        })
        */
      })
    },
    searchAlgolia: function () {
      // Algolia
      var client = algoliasearch('K2PX6XUYZD', 'ab6ff564e0cedf34e0716ad88fa36701')
      var index = client.initIndex('isustudyabroad')
      index.search('', { hitsPerPage: 100, facets: '*', filters: this.algoliaFilters }, function searchDone (err, content) {
        if (!err) {
          if (!this.initSeach) {
            this.createFilters(content)
          }
          // if (this.buildFilters) {
          this.trips = content
          this.buildMap(content)
          // }
          this.initSeach = true
        }
      }.bind(this))
    },
    createFilters: function (content) {
      var regionArr = []
      var typeArr = []
      _.each(content.hits, function (hit) {
        _.each(hit.regions, function (region) {
          var newRegion = {}
          newRegion.name = region
          newRegion.value = true
          regionArr.push(newRegion)
        })
        _.each(hit.types, function (type) {
          var newType = {}
          newType.name = type
          newType.value = true
          typeArr.push(newType)
        })
      })
      /* Filter out Duplicates */
      var regionArrUnique = []
      var regionFound = {}
      for (var k = 0; k < regionArr.length; ++k) {
        var stringifiedRegion = JSON.stringify(regionArr[k])
        if (regionFound[stringifiedRegion]) { continue }
        regionArrUnique.push(regionArr[k])
        regionFound[stringifiedRegion] = true
      }
      /* Filter out Duplicates */
      var typeArrUnique = []
      var typeFound = {}
      for (var l = 0; l < typeArr.length; ++l) {
        var stringifiedType = JSON.stringify(typeArr[l])
        if (typeFound[stringifiedType]) { continue }
        typeArrUnique.push(typeArr[l])
        typeFound[stringifiedType] = true
      }
      this.setRegions(regionArrUnique)
      this.setTypes(typeArrUnique)
    },
    filteredTrips: function () {
      var that = this
      _.each(that.markers, function (marker, i) {
        if (marker.trip.name === that.currentTrip.name) {
          marker.setVisible(true)
        } else {
          marker.setVisible(false)
        }
      })
    }
  },
  computed: {
    ...mapState({
      regions: state => state.regions,
      types: state => state.types
    }),
    algoliaRegions () {
      var regionsString = ''
      var i = 0
      _.each(this.regions, function (region) {
        if (region.value) {
          if (i !== 0) {
            regionsString = regionsString + ' OR '
          }
          regionsString = regionsString + 'regions: \'' + region.name + '\''
          i++
        }
      })
      return regionsString
    },
    algoliaTypes () {
      var typesString = ''
      var i = 0
      _.each(this.types, function (type) {
        if (type.value) {
          if (i !== 0) {
            typesString = typesString + ' OR '
          }
          typesString = typesString + 'types: \'' + type.name + '\''
          i++
        }
      })
      return typesString
    },
    algoliaFilters () {
      if (this.algoliaRegions && this.algoliaTypes) {
        return this.algoliaRegions + ' AND ' + this.algoliaTypes
      } else if (!this.initSeach) {
        return ''
      } else {
        return 'types: \'123456\''
      }
    }
  },
  watch: {
    'algoliaFilters': function () {
      this.buildFilters = true
      this.searchAlgolia()
    },
    'currentDest': function (currentDest) {
      var that = this
      if (this.loadingMap) {
        setTimeout(function () {
          _.each(that.markers, function (marker, i) {
            if (marker.dest === that.currentDest) {
              marker.setIcon(that.markerIconPicker(that.currentTrip, true))
            } else {
              marker.setIcon(that.markerIconPicker(that.currentTrip, false))
            }
          })
        }, 500)
      } else {
        _.each(that.markers, function (marker, i) {
          if (marker.dest === that.currentDest) {
            marker.setIcon(that.markerIconPicker(that.currentTrip, true))
          } else {
            marker.setIcon(that.markerIconPicker(that.currentTrip, false))
          }
        })
      }
    }
  }
}

var GmapsCubicBezier = function (lat1, long1, lat2, long2, lat3, long3, lat4, long4, resolution, map) {
  var points = []
  for (var it = 0; it <= 1; it += resolution) {
    points.push(this.getBezier({x: lat1, y: long1}, {x: lat2, y: long2}, {x: lat3, y: long3}, {x: lat4, y: long4}, it))
  }
  for (var i = 0; i < points.length - 1; i++) {
    var Line = new google.maps.Polyline({
      path: [new google.maps.LatLng(points[i].x, points[i].y), new google.maps.LatLng(points[i + 1].x, points[i + 1].y)],
      geodesic: true,
      strokeOpacity: 1,
      strokeColor: '#bdc7d1'
    })
    Line.setMap(map)
  }
}
GmapsCubicBezier.prototype = {
  B1: function (t) { return t * t * t },
  B2: function (t) { return 3 * t * t * (1 - t) },
  B3: function (t) { return 3 * t * (1 - t) * (1 - t) },
  B4: function (t) { return (1 - t) * (1 - t) * (1 - t) },
  getBezier: function (C1, C2, C3, C4, percent) {
    var pos = {}
    pos.x = C1.x * this.B1(percent) + C2.x * this.B2(percent) + C3.x * this.B3(percent) + C4.x * this.B4(percent)
    pos.y = C1.y * this.B1(percent) + C2.y * this.B2(percent) + C3.y * this.B3(percent) + C4.y * this.B4(percent)
    return pos
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
  #map,
  .overlay {
    height: calc(100% - 60px);
    /*height: 100%;*/
    width: 100%;
    position: absolute;
    background:#d9e8f1!important;
    transition: all .5s ease;
    top: 0;
    left: 0;
  }
  #map.rightActive,
  .overlay.rightActive {
    width: 65%;
    transition: all .5s ease;
  }
  .gmapPoly {
    color:#ccc!important;
  }

  @media (max-width : 769px) and (orientation: portrait) {
    #map.rightActive, 
    .overlay.rightActive {
      height: calc(55% - 60px);
      width:100%;
    }
  }
  @media (max-width : 769px) and (orientation: landscape) {
    #map,
    .overlay {
      height:calc(100% - 35px);
    }
  }
</style>
<style>
  .infoBox {
    text-align:center;
    color:#fff;
    font-size:1.125em;
    cursor: pointer;
  }
  .infoBox p {
    padding:.75em 5px 0;
    margin:0;
  }
  .infoBoxImg {
    background-size:cover;
    background-repeat:no-repeat;
    background-position:center;
    width:125px;
    height:70px;
    margin-bottom:0;
  }
  .overlay {
    background-color: #fff !important;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .overlay img {
    width: 90px;
  }
</style>



// WEBPACK FOOTER //
// Map.vue?a6b8e622